module.exports = __webpack_public_path__ + "static/media/Picture1 person.8eebd7f2.jpg";